var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.3327C5.39758 18.3327 1.66675 14.6018 1.66675 9.99935C1.66675 5.39685 5.39758 1.66602 10.0001 1.66602C14.6026 1.66602 18.3334 5.39685 18.3334 9.99935C18.3334 14.6018 14.6026 18.3327 10.0001 18.3327ZM10.0001 16.666C11.7682 16.666 13.4639 15.9636 14.7141 14.7134C15.9644 13.4632 16.6667 11.7675 16.6667 9.99935C16.6667 8.23124 15.9644 6.53555 14.7141 5.2853C13.4639 4.03506 11.7682 3.33268 10.0001 3.33268C8.23197 3.33268 6.53628 4.03506 5.28604 5.2853C4.03579 6.53555 3.33341 8.23124 3.33341 9.99935C3.33341 11.7675 4.03579 13.4632 5.28604 14.7134C6.53628 15.9636 8.23197 16.666 10.0001 16.666V16.666ZM7.50008 6.66602H12.5001L14.5834 9.58268L10.0001 14.166L5.41675 9.58268L7.50008 6.66602ZM8.35841 8.33268L7.59175 9.40768L10.0001 11.816L12.4084 9.40768L11.6417 8.33268H8.35841V8.33268Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCheckIcon);
export default __webpack_public_path__ + "static/media/crypto_check_icon.2e3bd24b4ad8e01ad161522dc9909cc6.svg";
export { ForwardRef as ReactComponent };